/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const Lamp = (props: IconProps) => (
  <Icon {...props}>
    <path
      d="M9,16.1973068 C7.20659589,15.1598786 6,13.2208471 6,11 C6,7.6862915 8.6862915,5 12,5 C15.3137085,5 18,7.6862915 18,11 C18,13.2208471 16.7934041,15.1598786 15,16.1973068 L15,21 L9,21 L9,16.1973068 Z M11,0 L13,0 L13,3 L11,3 L11,0 Z M1,10 L4,10 L4,12 L1,12 L1,10 Z M4.41421356,2.29 L6.53553391,4.41132034 L5.12132034,5.82553391 L3,3.70421356 L4.41421356,2.29 Z M17,4.41421356 L19.1213203,2.29289322 L20.5355339,3.70710678 L18.4142136,5.82842712 L17,4.41421356 Z M20,10 L23,10 L23,12 L20,12 L20,10 Z"
    />
  </Icon>
);
